import { Suspense } from "react"
import { createRoot } from "react-dom/client"
import { Provider } from "react-redux"
import App from "./App"
import "./index_.css"
import "./index.css"
import store from "./redux/store"
// Service Worker removido para simplificar cache busting
// import * as serviceWorker from "@/serviceWorker";
import "./i18n"

import "./components/styles/base.css"
// import * as Sentry from "@sentry/react";
// import {BrowserTracing} from "@sentry/tracing";
// import Smartlook from "smartlook-client";

// Importar utilidades de cache para debug
import "@/utils/cacheUtils"

// import {
//     useLocation,
//     useNavigationType,
//     createRoutesFromChildren,
//     matchRoutes,
// } from "react-router-dom";
import ErrorBoundary from "@/ErrorBoundary"

// SSO redirect: guardar token ANTES de que React monte, para evitar carrera con loadUser.
// Si no hacemos esto, el useEffect de App corre antes que el de Login y las peticiones
// autenticadas van sin token -> 401 -> interceptor redirige a /login -> se pierde el token.
let shouldSkipRender = false
if (
  typeof window !== "undefined" &&
  window.location.pathname.includes("/login")
) {
  const params = new URLSearchParams(window.location.search)
  const token =
    params.get("token") ?? params.get("auth_token") ?? params.get("access_token")
  if (token) {
    localStorage.setItem("auth_token", token)
    window.location.replace("/")
    shouldSkipRender = true
  }
}

// Verifica si el dominio está en los dominios permitidos
const allowedDomains = ["demo.motivy.co", "dev.motivy.co", "localhost"]
const isAllowedDomain = allowedDomains.some((domain) =>
  window.origin.includes(domain)
)
console.log("isAllowedDomain -> ", isAllowedDomain)

// Sentry desactivado temporalmente debido a problemas
// if (!/.localhost.*/.test(window.origin)) {
//     Sentry.init({
//         dsn: "https://ce2bf11ba820246bbde7da97e7ca44f0@o1186451.ingest.us.sentry.io/4508478300225536",
//         integrations: [new BrowserTracing({
//             routingInstrumentation: Sentry.reactRouterV6Instrumentation(
//                 React.useEffect,
//                 useLocation,
//                 useNavigationType,
//                 createRoutesFromChildren,
//                 matchRoutes,
//             ),
//         })],

//         // Set tracesSampleRate to 1.0 to capture 100%
//         // of transactions for performance monitoring.
//         // We recommend adjusting this value in production
//         tracesSampleRate: 1.0,
//         tracePropagationTargets: [/^https:\/\/deuna\.motivytest\.co/],
//     });
// }

const rootElement = document.getElementById("root")
const root = rootElement ? createRoot(rootElement) : null

// Smartlook desactivado temporalmente
// const SMARTLOOK_KEY = "9c28adc5151d773fe5d444f68d6264b51fdf0165";

// try {
//     Smartlook.init(SMARTLOOK_KEY, { region: "eu" });
// } catch (error) {
//     console.warn('Smartlook initialization failed:', error);
//     // Don't block the app if Smartlook fails
// }

if (root && !shouldSkipRender) {
  root.render(
    <Provider store={store}>
      <Suspense fallback={null}>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </Suspense>
    </Provider>
  )
}

// Service Worker deshabilitado para evitar problemas de cache con imports dinámicos
// Si necesitas funcionalidad offline en el futuro, considera implementar una estrategia más simple
